import SEOHelmet from '@/components/SEOHelmet';
import { useState } from 'react';
import LoadingSpinner from '@/components/LoadingSpinner';
import styles from './explore-data.module.scss';
import Button from '@/components/Button';
import ArrowUpRightFromSquare from '@/assets/icons/arrow-up-right-from-square.svg?react';
import { gaPushEvent } from '@/utils/analytics';

const ExploreData = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const explorerUrl = 'https://gannet.ai/explorer';

  return (
    <section className={styles['explore-data-wrapper']}>
      <SEOHelmet
        title="Explore Data"
        description="Explore the data in GANNET"
      />
      <h2>Explore Data</h2>
      <p>Explore the data in GANNET with our interactive data explorer.</p>

      <div className={styles['embed-container']} data-testid="explorer-embed">
        {loading && (
          <div className={styles['embed-loading']} aria-hidden={false}>
            <LoadingSpinner />
          </div>
        )}

        {error && (
          <div className={styles['embed-fallback']} role="status">
            <p>Preview unavailable. Open the explorer in a new tab:</p>
            <a
              href={explorerUrl}
              target="_blank"
              rel="noopener noreferrer"
              className={styles['open-link']}
              onClick={() => {
                gaPushEvent('click_open_explorer_fallback_link');
              }}
            >
              Open GANNET Explorer
            </a>
          </div>
        )}

        {!error && (
          <iframe
            src={explorerUrl}
            title="GANNET Explorer — interactive data explorer"
            loading="lazy"
            sandbox="allow-popups allow-forms allow-scripts allow-same-origin"
            allowFullScreen
            onLoad={() => setLoading(false)}
            onError={() => {
              setLoading(false);
              setError(true);
            }}
          />
        )}
      </div>

      <Button
        className={styles['open-cta']}
        onClick={() => {
          gaPushEvent('click_open_explorer_new_tab');
          window.open(explorerUrl, '_blank', 'noopener,noreferrer');
        }}
      >
        Open in new tab
        <ArrowUpRightFromSquare />
      </Button>
    </section>
  );
};

export default ExploreData;
